import Req from '../../$axios';

const serviceModule = {
  // 项目概览
  projectOverview(params) {
    return Req({
      url: 'projectStatistics/projectOverview',
      method: 'get',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  // 任务优先级分布
  sortRuleOverview(params) {
    return Req({
      url: 'projectStatistics/sortRuleOverview',
      method: 'get',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  // 任务完成情况概览
  taskCompletionOverview(params) {
    return Req({
      url: 'projectStatistics/taskCompletionOverview',
      method: 'get',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  // 项目进度概览
  projectProgressOverview(params) {
    return Req({
      url: 'projectStatistics/projectProgressOverview',
      method: 'get',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  // 用户任务完成概览
  userTaskCompletedOverview(params) {
    return Req({
      url: 'projectStatistics/userTaskCompletedOverview',
      method: 'get',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  },

  // 获取项目概览表
  getTaskStatusOverviewTable(params) {
    return Req({
      url: 'projectStatistics/projectOverviewTable',
      method: 'post',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  // 获取任务优先级分布表
  getTaskSortRuleOverviewTable(params) {
    return Req({
      url: 'projectStatistics/sortRuleOverviewTable',
      method: 'post',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  // 获取任务优先级分布表
  getProjectProgressOverviewTable(params) {
    return Req({
      url: 'projectStatistics/projectProgressOverviewTable',
      method: 'get',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  },

  // 导出项目概览表
  exportProjectOverviewTable(params) {
    return Req({
      url: 'projectStatistics/exportProjectOverviewTable',
      method: 'post',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  // 导出任务优先级分布表
  exportSortRuleOverviewTable(params) {
    return Req({
      url: 'projectStatistics/exportSortRuleOverviewTable',
      method: 'post',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  // 导出用户任务执行情况概览表
  exportUserTaskCompletedOverview(params) {
    return Req({
      url: 'projectStatistics/exportUserTaskCompletedOverview',
      method: 'get',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  // 导出项目进展走势表
  exportProjectProgressOverviewTable(params) {
    return Req({
      url: 'projectStatistics/exportProjectProgressOverviewTable',
      method: 'get',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  },

   // 获取筛选条件
   getTableFilter(params) {
    return Req({
      url: 'projectStatistics/getFilter',
      method: 'get',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  }
};

export default {
  ...serviceModule
};
